import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions/userActions';
import { routes } from '../../constants';

const groupAndFilterRoutes = user => {
  const toRoleName = role => role.name;
  const isAdmin = user.roles.map(toRoleName).includes('admin');
  const isInRole = route => user.roles.map(toRoleName).find(name => route.role.includes(name)) || isAdmin;
  const getRouteDistinctGroups = () => [...new Set(routes.map(route => route.group))];
  return getRouteDistinctGroups().reduce((prev, name) => {
    const isInGroup = route => route.group === name;
    const items = routes.filter(isInGroup).filter(isInRole);
    if (items.length) {
      prev.push({
        name,
        items,
      });
    }
    return prev;
  }, []);
};

const defaultState = {
  token: null,
  loading: true,
  loaded: false,
  loggedIn: false,
  user: {},
  errorMessage: '',
  successMessage: '',
  message: '',
  roles: [],
  routes: [],
};

const reducer = handleActions(
  {
    [combineActions(actions.loginSuccess, actions.loginFromTokenSuccess)]: (state, { payload: { user, token } }) => {
      return { ...state, token, user, loggedIn: true, loading: false, routes: groupAndFilterRoutes(user) };
    },
    [actions.loginFail]: (state, { payload: { error } }) => {
      return { ...state, errorMessage: error, loading: false };
    },
    [actions.resetPasswordSuccess]: state => {
      return { ...state, successMessage: 'Password reset email sent.', loading: false };
    },
    // [actions.setRolesSuccess]: (state, { payload: { roles } }) => {
    //   return {
    //     ...state,
    //     user: {
    //       ...state.user,
    //       user: {
    //         ...state.user.user,
    //         roles,
    //       },
    //     },
    //     roles,
    //   };
    // },
    [actions.logout]: state => {
      return { ...state, token: null, loggedIn: false, loading: false };
    },
    [actions.setLoading]: (state, { payload: { loading, message } }) => {
      if (!loading) {
        return { ...state, loading, message: '' };
      }
      let loadingMessage;
      if (!message && !state.message) {
        loadingMessage = 'Loading...';
      } else {
        loadingMessage = message;
      }

      return { ...state, loading, message: loadingMessage };
    },
    [actions.setAppLoaded]: (state, { payload: { loaded } }) => {
      return { ...state, loaded };
    },
    [actions.updatePasswordFail]: (state, { payload: { message } }) => {
      return { ...state, errorMessage: message };
    },
  },
  defaultState
);

export default reducer;
